import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Label } from 'reactstrap';
import Toggle from 'react-toggle';

const ListGroupEmptyItem = ({ children }) => (
  <li className="list-group-item align-items-start p-2">
    <div className="d-flex w-100 justify-content-between">{children}</div>
  </li>
);

ListGroupEmptyItem.propTypes = {
  children: PropTypes.node.isRequired,
};

const ListGroupItem = ({
  heading,
  details,
  onRemove,
  onEditClicked,
  isEditingActive,
  disabled,
  onDisableClicked,
  disableAction,
  imageUrl,
}) => (
  <li className="list-group-item align-items-start p-2">
    <div className="d-flex w-100 justify-content-between align-items-center">
      {heading && <div className="font-weight-bold">{heading}</div>}
      {!isEditingActive && (
        <div className="actions">
          {onDisableClicked && (
            <Fragment>
              <img
                src={imageUrl}
                className="img-option align-middle me-3"
                alt=""
              />
              <span className="me-3">{disableAction}</span>
              <Toggle
                className="align-middle me-3"
                checked={disabled}
                onChange={(e) => onDisableClicked(e.target.checked)}
              />
            </Fragment>
          )}
          {heading && onEditClicked && (
            <button
              type="button"
              className="btn btn-link pe-2"
              onClick={onEditClicked}
            >
              edit
            </button>
          )}
          {heading && onRemove && (
            <button
              type="button"
              className="btn btn-link p-0"
              onClick={onRemove}
            >
              remove
            </button>
          )}
        </div>
      )}
    </div>
    {details && (
      <div className="d-flex w-100 align-items-center mt-1">
        {details}
        {!heading && !onRemove && onEditClicked && (
          <div style={{ display: 'block', width: '60px' }}></div>
        )}
        {!heading && onEditClicked && (
          <button
            type="button"
            className="btn btn-link pe-2"
            onClick={onEditClicked}
          >
            edit
          </button>
        )}
        {!heading && onRemove && (
          <button type="button" className="btn btn-link p-0" onClick={onRemove}>
            remove
          </button>
        )}
      </div>
    )}
  </li>
);

ListGroupItem.propTypes = {
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  details: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onRemove: PropTypes.func,
  onEditClicked: PropTypes.func,
  isEditingActive: PropTypes.bool,
  disabled: PropTypes.bool,
  onDisableClicked: PropTypes.func,
  disableAction: PropTypes.string,
};

const ListGroup = ({ label, children }) => (
  <div>
    {label && <Label className="form-label">{label}</Label>}
    <ul className="list-group mb-1">{children}</ul>
  </div>
);

ListGroup.propTypes = {
  children: PropTypes.arrayOf(ListGroupItem),
  label: PropTypes.string,
};

export { ListGroup, ListGroupItem, ListGroupEmptyItem };
